module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.containerClass
  }, [_c('div', {
    staticClass: "notification-wrapper__icon"
  }, [_c('i', {
    staticClass: "icon",
    class: _vm.iconClass
  })]), _vm._v(" "), _c('div', {
    staticClass: "notification-wrapper__content"
  }, [_c('a', {
    staticClass: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.config.item.title) + "\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "close",
    on: {
      "click": _vm.config.close
    }
  }, [_c('i', {
    staticClass: "notifications--icon"
  }, [_c('icon-close')], 1)]), _vm._v(" "), _c('div', [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.config.item.text))]), _vm._v(" "), (_vm.description) ? _c('h4', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e(), _vm._v(" "), (_vm.firstAction) ? _c('button', {
    staticClass: "button button--default-ghost",
    on: {
      "click": _vm.firstAction.action
    }
  }, [_vm._v(_vm._s(_vm.firstAction.text))]) : _vm._e(), _vm._v(" "), (_vm.secondAction) ? _c('button', {
    staticClass: "button button--default-ghost",
    on: {
      "click": _vm.secondAction.action
    }
  }, [_vm._v(_vm._s(_vm.secondAction.text))]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0e2e246"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/notifications/NotificationBody.vue
// module id = 320
// module chunks = 22